import React, { useState, useEffect } from 'react';
import { API_URL } from '../services/api';
import './PointsHistory.css';
import { useNavigate } from 'react-router-dom';

const PointsHistory: React.FC = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPointsHistory();
  }, []);

  const fetchPointsHistory = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/points/history`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setTransactions(data.transactions);
        setBalance(data.balance);
      }
    } catch (error) {
      console.error('Failed to fetch points history:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTransactionIcon = (type: string) => {
    switch(type) {
      case 'earn': return '⭐';
      case 'redeem': return '🛒';
      case 'bonus': return '🎁';
      case 'refund': return '↩️';
      default: return '📝';
    }
  };

  const getTransactionColor = (type: string) => {
    switch(type) {
      case 'earn': return '#10b981';
      case 'redeem': return '#f59e0b';
      case 'bonus': return '#8b5cf6';
      case 'refund': return '#ef4444';
      default: return '#6b7280';
    }
  };

  if (loading) return <div className="loading">Loading points history...</div>;

  return (
    <div className="points-history">
       {/* Add Back Button Header */}
      <div className="points-history-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1>Reward History</h1>
      </div>

      <div className="points-summary">
        <div className="points-balance">
          <span className="balance-icon">
            <img src="/money_bag_1_trans.png" alt="Gimbiya" className="logo-image" />
          </span>
          <div className="balance-details">
            <span className="balance-label">Current Balance</span>
            <span className="balance-value">{balance} points</span>
            <span className="balance-value-currency">≈ ₦{(balance * 0.1).toLocaleString()}</span>
          </div> 
        </div>
      </div> 

      <div className="transactions-list">
        <h3>Transaction History</h3>
        {transactions.length === 0 ? (
          <div className="no-transactions">
            <p>No points transactions yet</p>
            <p className="hint">Complete orders to earn points!</p>
          </div>
        ) : (
          transactions.map((tx: any, index) => (
            <div key={index} className="transaction-item">
              <div className="transaction-icon" style={{ backgroundColor: getTransactionColor(tx.type) + '20' }}>
                <span>{getTransactionIcon(tx.type)}</span>
              </div>
              <div className="transaction-details">
                <div className="transaction-description">{tx.description}</div>
                <div className="transaction-date">
                  {new Date(tx.createdAt).toLocaleDateString()}
                </div>
              </div>
              <div className={`transaction-amount ${tx.type === 'earn' || tx.type === 'bonus' ? 'positive' : 'negative'}`}>
                {tx.type === 'earn' || tx.type === 'bonus' ? '+' : '-'}{tx.amount} pts
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PointsHistory;